export const urlRailway = "https://aubert-go-production.up.railway.app/";
export const urlRender = "https://aubert-go.onrender.com/";
